import { useState } from 'react'
import { cn } from '@/lib/tailwind.utils'
import { Skeleton } from '@/components/ui/skeleton'

type ImagePreviewProps = {
  // Presigned S3 URL, handed straight to <img src> — no manual fetch/blob layer needed since
  // <img> issues its own uncredentialed GET.
  url: string
  alt: string
  onError: () => void
}

export const ImagePreview = ({ url, alt, onError }: ImagePreviewProps) => {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <div className="relative h-full w-full">
      {isLoading && <Skeleton className="absolute inset-0 h-full w-full" />}
      <img
        src={url}
        alt={alt}
        className={cn('h-full w-full object-contain', isLoading && 'invisible')}
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setIsLoading(false)
          onError()
        }}
      />
    </div>
  )
}
